var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28 16L12 16M28 8L12 8M28 24L12 24M6.66667 16C6.66667 16.7364 6.06971 17.3333 5.33333 17.3333C4.59695 17.3333 4 16.7364 4 16C4 15.2636 4.59695 14.6667 5.33333 14.6667C6.06971 14.6667 6.66667 15.2636 6.66667 16ZM6.66667 8C6.66667 8.73638 6.06971 9.33333 5.33333 9.33333C4.59695 9.33333 4 8.73638 4 8C4 7.26362 4.59695 6.66667 5.33333 6.66667C6.06971 6.66667 6.66667 7.26362 6.66667 8ZM6.66667 24C6.66667 24.7364 6.06971 25.3333 5.33333 25.3333C4.59695 25.3333 4 24.7364 4 24C4 23.2636 4.59695 22.6667 5.33333 22.6667C6.06971 22.6667 6.66667 23.2636 6.66667 24Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.e872c0ec7eaea5f3f1ebe68ea3d19d4a.svg";
export { ForwardRef as ReactComponent };